import React, { useMemo, useState } from 'react';

import Input from '@uikit/Form/Input/Input';

import { SWIFT_COUNTRY_FEES } from '../../constants';
import { filterSwiftCountries, formatSwiftFee } from '../../utils';

import './SwiftCountryFeeTable.scss';

function SwiftCountryFeeTable(): JSX.Element {
  const [searchQuery, setSearchQuery] = useState<string>('');

  const filteredCountries = useMemo(
    () => filterSwiftCountries(SWIFT_COUNTRY_FEES, searchQuery),
    [searchQuery]
  );

  const counterText = searchQuery.trim()
    ? `${filteredCountries.length} of ${SWIFT_COUNTRY_FEES.length} countries`
    : `${SWIFT_COUNTRY_FEES.length} countries`;

  return (
    <div className="swift-country-fee-table">
      <div className="swift-country-fee-table__toolbar">
        <Input
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
          placeholder="Search your country…"
          icon="search"
          isClearable
          onClear={() => setSearchQuery('')}
          className="swift-country-fee-table__search"
        />
        <span className="swift-country-fee-table__counter">{counterText}</span>
      </div>

      {filteredCountries.length === 0 ? (
        <div className="swift-country-fee-table__empty">
          No country matches “{searchQuery.trim()}”. Countries not listed here (with predicted
          correspondent fees) are charged 21.71 USD per transfer.
        </div>
      ) : (
        <ul className="swift-country-fee-table__list">
          {filteredCountries.map((item) => (
            <li key={item.country} className="swift-country-fee-table__item">
              <span className="swift-country-fee-table__country">{item.country}</span>
              <span className="swift-country-fee-table__leader" aria-hidden="true" />
              <span className="swift-country-fee-table__fee">{formatSwiftFee(item.feeUsd)}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default SwiftCountryFeeTable;
